import {HttpClient, ClientConfig} from '../../http';

const userPath = `/b/admin/users`;

export const setupTrainingEndpoints = (client: HttpClient) => {
  return {
    transitionPhase: (
      {userId, action}: {userId: string; action: string},
      config?: ClientConfig
    ) => {
      return client.post<string, {message: string}>(
        `${userPath}/${userId}/training/guided/phase/transition`,
        {action},
        config
      );
    },
  };
};
